import frappe from './frappe';
const bcrypt = require('bcryptjs');

async function verifyPassword(passwordIngresada, contrasenaEncriptada) {
    try {
        return await bcrypt.compare(passwordIngresada, contrasenaEncriptada);
    } catch (error) {
        console.error('Error al verificar la contraseña:', error);
        return false;
    }
}

function mapCustomerToUser(customer) {
    return {
        id: customer.name,
        name: customer.customer_name,
        email: customer.email_id,
        address: customer.custom_direccion || '',
        phone: customer.mobile_no || '',
    };
}

// Busca un Customer en Frappe por su correo (email_id)
export async function getCustomerByEmail(email) {
    try {
        const fields = ["name", "customer_name", "email_id", "mobile_no", "custom_direccion", "custom_password_hash"];
        const { data } = await frappe.get(
            `/api/resource/Customer?filters=${encodeURIComponent(JSON.stringify([["email_id", "=", email]]))}&fields=${encodeURIComponent(JSON.stringify(fields))}&limit_page_length=1`
        );
        return data.data[0] || null;
    } catch (error) {
        console.error('Error al buscar cliente por correo:', error.response?.data || error.message);
        throw error;
    }
}

// Servicio de inicio de sesión
export async function login(userData) {
    try {
        if (!userData || !userData.userName || !userData.password) {
            return { success: false, message: 'Datos de usuario incompletos' };
        }

        const customer = await getCustomerByEmail(userData.userName);

        if (!customer) {
            return { success: false, message: 'Usuario no encontrado' };
        }

        if (!customer.custom_password_hash) {
            return { success: false, message: 'Esta cuenta no tiene una contraseña configurada. Contacte a soporte.' };
        }

        // Verificar contraseña
        const passwordMatch = await verifyPassword(userData.password, customer.custom_password_hash);

        if (!passwordMatch) {
            return { success: false, message: 'Contraseña incorrecta' };
        }

        // Retornar datos del usuario en caso de éxito
        return {
            success: true,
            data: mapCustomerToUser(customer),
        };

    } catch (error) {
        console.error('Error al iniciar sesión:', error.response?.data || error.message);
        return { success: false, message: 'Error en la verificación del usuario' };
    }
}

export async function verificarUsuarioPorCorreo(email) {
    try {
        if (!email) {
            throw new Error('Correo no proporcionado');
        }

        const customer = await getCustomerByEmail(email);
        return !!customer;
    } catch (error) {
        console.error("Error al verificar usuario por correo:", error.response?.data || error.message);
        return false; // Asumimos que no existe si hay error
    }
}

export async function getUserByEmail(email) {
    const customer = await getCustomerByEmail(email);
    return customer ? mapCustomerToUser(customer) : null;
}
